var sprigPlayEvent = function sprigPlayEvent() {
  var _window;
  if ((_window = window) !== null && _window !== void 0 && _window.Sprig) {
    // When a user plays a track
    window.Sprig('track', 'Track Played');
  }
};
export default sprigPlayEvent;